import _regeneratorRuntime from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-runtime/helpers/asyncToGenerator';
//
//
//
//
//

import createproject from '~/components/create-project.vue';
export default {
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query,
          error = _ref.error;
      var id, userData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              id = query.custID;
              userData = store.state.authUser;

              console.log(userData);

              if (!(userData.roleID !== 'SuperAdmin')) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return', error({ statusCode: 401, message: 'Permision Denied' }));

            case 5:
              return _context.abrupt('return', {
                tokenData: userData,
                id: id
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),

  components: {
    createproject: createproject
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/admin/customer/create-project.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/admin/customer/create-project.vue
// module chunks = 14